const SectionTitle = ({ title }: { title: string }) => (
  <div className="data-tit-box">{title}</div>
);
export default SectionTitle;
